module.exports = __webpack_public_path__ + "img/WP2023-logo-dubai.dbe592dd.png";